import { fetchSsrHtml, fetchSsrStyles } from "../../core/common/ssr-utils.js";
import { getSsrBaseUrl } from "./coursesu-env.js";
import { getPosExtId } from "./utils.js";

/**
 * The recipe recap button is a link to the very old version of the History page in My Space, which can be seen only on CoursesU
 * They currently want us to maintain it only because we don't have an url pointing to the history directly and apparently CoursesU links
 * to the recap page when sending confirmation mails for orders which contain recipes
 * Until they can't link to the new order history they want us to maintain the recap page
 */

/** Module-level storage for the basket-preview HTML prefetched before page init */
let _prefetchedBasketPreviewHtml = null;

export async function prefetchBasketPreview(headers) {
  try {
    fetchSsrStyles('/v3/styles/catalog/basket-preview', getSsrBaseUrl());
    _prefetchedBasketPreviewHtml = await fetchSsrHtml(
      '/v3/catalog/my-space/basket-preview',
      headers,
      { embed: true, show_tab_selector: false, in_drawer: false, store_id: getPosExtId() },
      getSsrBaseUrl()
    );
  } catch (err) {
    console.error('[CoursesU] basket-preview SSR prefetch failed', err);
  }
}

/** *************************************** RECIPE RECAP BUTTON **************************************** */


export function initRecipeRecapButton() {
  const template = document.createRange().createContextualFragment(
    `
    <li id="mealzMesRepas" class="account-dropdown-new-list-item">
      <a class="account-link">
        <div class="account-dropdown-text">
          <span class="account-link-text"> Mes repas </span>
          <span id="mealzRecipeCounter" class="mealz-recipe-counter"></span>
        </div>
      </a>
    </li>
    `
  );

  template.firstElementChild.addEventListener("click", () => location.href = "/mes-repas.html");
  const itemSection =  document.getElementsByClassName('account-dropdown-new-list')[0];
  const toInjectBefore = itemSection?.getElementsByClassName('account-dropdown-new-list-item')[1];
  if (!toInjectBefore?.parentNode) return;

  toInjectBefore.parentNode.insertBefore(template, toInjectBefore);
  const counter = document.getElementById('mealzRecipeCounter');
  initRecipeCounter(counter);
}


function initRecipeCounter(counter) {
  counter.classList.add('mealz-hidden');
  globalThis.mealz.basket.recipeCount().subscribe((recipesCount) => {
    counter.innerHTML = recipesCount;
    recipesCount == 0
      ? counter.classList.add('mealz-hidden')
      : counter.classList.remove('mealz-hidden');
  });
}


/** *************************************** RECIPE RECAP PAGE **************************************** */


/**
 * This is a link to the very version of old order-history, which can be seen only on CoursesU
 * They currently want us to maintain it only because we don't have an url pointing to the order-history directly and apparently CoursesU links
 * to the recap page when sending confirmation mails for orders which contain recipes
 * Until they can't link to the new order history they want us to maintain the recap page
 */

const PAGE_TEMPLATE = document.createRange().createContextualFragment(`
  <div class='mealz-recap-page-header'>
    <div class='mealz-recap-page-header__breadcrumbs'>
      <div class="mealz-recap-page-header__breadcrumbs__home" href='${globalThis.location.origin}'></div>
      <div class="mealz-recap-page-header__breadcrumbs__caret"></div>
      <a href='${globalThis.location.origin}/mon-compte'> Mon compte </a>
      <div class="mealz-recap-page-header__breadcrumbs__caret"></div>
      <a> Mes repas </a>
    </div>
    <div class='mealz-recap-page-header__title'>
      <span>Mes repas (<span id="mealzMesRepasRecipeCounter" class="mealz-recipe-counter"></span>)
    </div>
    <div class='mealz-recap-page-header__subtitle'>
      Les ingrédients pour ces recettes sont actuellement dans votre panier.
      Retrouvez ici le détail des recettes pour les réaliser chez vous.
    </div>
  </div>
  <div class="mealz-recap-page__main__container">
    <div class="mealz-recipes-page__header">
      <div id="catalogButton" class="mealz-recipes-page__tab">
        Recettes
      </div>
      <div id="recipeRecapButton" class="mealz-recipes-page__tab mealz-recipes-page__tab__curent">
        Mes repas
      </div>
    </div>
    <div class="mealz-recap-page__sub__container">
      <div class="mealz-recap-page__sub__container__left">
        <div class="mealz-recap-page__left__header ">
          <h1 id='recapPageLeftHeader'>
          </h1>
        </div>
        <div class="mealz-recap-page__left__recipe__block">
          <p id="previewBlockHeader" class="mealz-recap-page__recipe__block__header">
            Vous avez sélectionné <span id="nbOfMeals"></span> repas. <br />
            On y jette un dernier petit coup d'oeil ?
          </p>
          <div id="mealzBasketPreviewPlaceholder"></div>
        </div>
        <div class="mealz-recap-page__left__button__raw">
          <div class="mealz-recap-page__raw__continue__button">
            <span id="continueButton">
              Continuer mes achats
            </span>
          </div>
          <button class="mealz-recap-page__raw__remove__all__button">
            <span id="removeAllButton">
              Retirer tous les repas
            </span>
          </button>
        </div>
      </div>
      <div class="mealz-recap-page__sub__container__right">
        <div class="mealz-recap-page__right__card">
          <h3 class="mealz-recap-page__right__card__header">
            Récapitulatif des repas
          </h3>
          <hr class="mealz-recap-page__right__card__divider">
          <p id="rightCardStats" class="mealz-recap-page__right__card__stats">
          </p>
          <div class="mealz-recap__card__comfirm_raw">
            <button id="confirmOrderButton">
              <span id="confirmOrderText">OK, voir mon panier</span>
            </button>
          </div>
          <!-- <p id="rightCardFooter" class="mealz-recap__right__card__footer"></p> -->
        </div>
      </div>
    </div>
  `);

let recapLastNumberOfRecipes = 0

export function initRecapPage(){
  injectPageFragment();
  globalThis.mealz.basket.recipeCount().subscribe((recipeCount) => updateRecapPage(recipeCount));
  const mutationTarget = document.getElementsByClassName('mealz-recap-page__left__recipe__block')[0];
  const observedAtts = { attributes: false, childList: true, subtree: true };
  const listMutationObserver = new MutationObserver(openDisplayOnClickInRecap);
  listMutationObserver.observe(mutationTarget, observedAtts);
  const counter = document.getElementById('mealzMesRepasRecipeCounter');
  initRecipeCounter(counter);
}

function injectPageFragment() {
  const pagePlaceholder = document.getElementById("primary");
  if (!pagePlaceholder) return;
  updateRecapPage(globalThis.mealz.basket.recipeCount()?.value);
  initButtonListeners();
  pagePlaceholder.replaceWith(PAGE_TEMPLATE);

  if (_prefetchedBasketPreviewHtml) {
    const placeholder = document.getElementById('mealzBasketPreviewPlaceholder');
    placeholder?.replaceWith(document.createRange().createContextualFragment(_prefetchedBasketPreviewHtml));
  }
}

function initButtonListeners() {
  const catalogButton = PAGE_TEMPLATE.getElementById("catalogButton");
  const confirmOrderButton = PAGE_TEMPLATE.getElementById("confirmOrderButton");
  const continueButton = PAGE_TEMPLATE.getElementById("continueButton");
  const removeAllButton = PAGE_TEMPLATE.getElementById("removeAllButton");
  catalogButton.addEventListener("click", () => location.href = '/idees-repas.html', false);
  confirmOrderButton.addEventListener("click", () => location.href = '/panier', false);
  continueButton.addEventListener("click", () => location.href = '/idees-repas.html', false);
  removeAllButton.addEventListener("click", () => globalThis.mealz.basket.reset(), false);
}

function openDisplayOnClickInRecap() {
  const items = Array.from(
    document
      .getElementsByClassName('mealz-recap-page__left__recipe__block')[0]
      .getElementsByClassName('mealz-basket-preview-line clickable')
  );
  if (recapLastNumberOfRecipes < items.length) {
    items.forEach(item => 
      item.addEventListener('click', () => globalThis.mealz.recipes.openDetails(item.id))
    );
  }
  recapLastNumberOfRecipes = items.length;
}

/**
 * Call each time recipeCount changed and on load
 * @param {recipesCount, entriesCount, totalPrice } recipeCount
 */
function updateRecapPage(recipeCount) {
  const page = document.getElementsByClassName('mealz-recap-page__main__container')[0];
  if (!page) return;
  const previewBlockHeader = page.querySelector("#previewBlockHeader");
  const leftHeader = page.querySelector("#recapPageLeftHeader");
  const rightCardStats = page.querySelector("#rightCardStats");
  const removeAllButton = page.querySelector("#removeAllButton");

  if (recipeCount > 0) {
    const nbOfMeals = page.querySelector("#nbOfMeals");
    previewBlockHeader.classList.remove("mealz-hidden");
    removeAllButton.classList.remove("mealz-hidden");
    leftHeader.innerHTML = "Avant de passer au panier...";
    nbOfMeals.innerHTML = recipeCount;
    rightCardStats.innerHTML = `${recipeCount} repas`;
  } else {
    previewBlockHeader.classList.add("mealz-hidden");
    removeAllButton.classList.add("mealz-hidden");
    leftHeader.innerHTML = "Mes repas";
    rightCardStats.innerHTML = `0 repas, 0 produits`;
  }
}
